import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'appProvider',
  isDragable: false,
  canOpen: false,
  canEdit: true,
  canCreate: false,
  canRemove: true,
  editURL: '',
  emptyMessage: "You don't feedback from the app, please wait.",
  fields: [
    {
      attributeName: 'id',
      label: 'ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Global app feedback ID.',
      default: '',
      canEdit: false,
      canCreate: false,
      width: '120px',
      canOrder: true,
      canFilter: true,
      exactWidth:'100px'
    },
    {
      attributeName: 'uploadTimestamp',
      label: 'Time',
      type: FormInputTypes.TIMESTAMP,
      helpText: 'Date of feedback message was sent by the user.',
      default: '',
      canEdit: false,
      canCreate: false,
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'userName',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: false,
      canCreate: false,
      default: '',
      helpText: 'Name of the user.',
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'country',
      label: 'Country',
      type: FormInputTypes.COUNTRY_FLAG,
      canEdit: false,
      canCreate: false,
      default: '',
      helpText: 'Country of feedback message was sent by the user.',
      canOrder: true,
      canFilter: true,
      exactWidth:'120px'
    },
    {
      attributeName: 'filePath',
      label: 'Message',
      type: FormInputTypes.AUDIO,
      canEdit: false,
      canCreate: false,
      default: '',
      helpText: 'Audio message from the user app.',
    },
    {
      attributeName: 'status',
      label: 'Status',
      type: FormInputTypes.SELECT,
      options: [
        { name: 'New', value: 'new' },
        { name: 'Discarded', value: 'discarded' },
        { name: 'Sent to speaker', value: 'sent' },
        { name: 'Answered', value: 'answered' },
      ],
      canEdit: true,
      canCreate: false,
      default: ['new'],
      helpText: 'Mark the status feedback.',
      canOrder: true,
      canFilter: true,
      exactWidth:'200px'
    },
  ],
};
